const CURRENCY_ALIASES = {
  DH: 'MAD',
  MAD: 'MAD',
  EUR: 'EUR',
  EURO: 'EUR',
};

export const DISPLAY_CURRENCY = 'MAD';

export const normalizeCurrencyCode = (currency) => {
  const code = (currency || DISPLAY_CURRENCY).toUpperCase();
  return CURRENCY_ALIASES[code] || DISPLAY_CURRENCY;
};

export const formatMoney = (amount, currency = DISPLAY_CURRENCY) => {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
    return '—';
  }

  const code = normalizeCurrencyCode(currency);
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code === 'MAD' || code === 'DH' ? 'MAD' : code,
      maximumFractionDigits: 0,
    }).format(Number(amount));
  } catch {
    return `${Number(amount).toLocaleString()} MAD`;
  }
};

export const formatMad = (amount) => {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) {
    return '—';
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'MAD',
      maximumFractionDigits: 0,
    }).format(Number(amount));
  } catch {
    return `${Number(amount).toLocaleString()} MAD`;
  }
};

export const formatPrice = formatMad;
export const formatEuro = (amount) => formatMad(amount);
